import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import InputComponent from "../components/InputComponent";
import Pattern from "../assets/images/pattern.png";
import LoginBg1 from "../assets/images/login-02.png";
import Logo from "../assets/images/new_vitalX_logo.svg";
import { resetPassword, sendOTPForForgotPassword, verifyOTPForgotPassword } from "../services/authApi";
import { showToast } from "../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import { otpValidationSchema, passwordValidationSchema, phoneValidationSchema } from "../utils/validations/registrationValidation";
import { Formik, Form, useFormik } from "formik";
import { FaSpinner } from "react-icons/fa";


const ForgotPassword = () => {

    const navigate = useNavigate();
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [step, setStep] = useState(1);
    const [errorMessage, setErrorMessage] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(false);

    const phoneFormik = useFormik({
        initialValues: {
            phoneNumber: "",
        },
        validationSchema: phoneValidationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const { status, message } = await sendOTPForForgotPassword(values.phoneNumber);
            if (status) {
                setPhoneNumber(values.phoneNumber);
                showToast(message, "success");
                setErrorMessage(null);
                setTimeout(() => {
                    setStep(2);
                }, 1000);
            } else {
                console.error("Failed to send OTP:", message);
                setErrorMessage(message);
            }
            setLoading(false);
        },
    });

    const otpFormik = useFormik({
        initialValues: {
        otp: "",
        },
        validationSchema: otpValidationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const { status, message, data } = await verifyOTPForgotPassword(phoneNumber,values.otp);
            if (status) {
                setToken(data?.token);
                showToast(message, "success");
                setErrorMessage(null);
                setTimeout(() => {
                    setIsOtpVerified(true);

                    setStep(3);
                }, 1000);
            } else {
                setIsOtpVerified(false);
                setErrorMessage(message);
            }
            setLoading(false);

        },
    });

    const passwordFormik = useFormik({
        initialValues: {
            password: "",
            confirmPassword: "",

        },
        validationSchema: passwordValidationSchema,
        onSubmit: async (values) => {
            if(isOtpVerified){
                setLoading(true);
                const { status, message } = await resetPassword({token, password: values.password});
                if (status) {
                    showToast(message, "success");
                    setErrorMessage(null);
                    setTimeout(() => {
                        navigate("/clinic/login");
                    }, 1000);
                } else {
                    console.error("Password reset failed:", message);
                    setErrorMessage(message);
                }
                setLoading(false);

            } else {
                setErrorMessage("OTP not verified");
            }
        },
    });

    return (
        <div className="app-layout-blank flex flex-auto flex-col max-h-auto">
            <div className="flex w-full min-h-screen">
                <div className="bg-no-repeat bg-cover py-6 px-16 flex-col justify-between hidden lg:flex  relative overflow-hidden bg-gradient-to-t from-[#2E37A4] from-5% via-[#81bbf5] via-30% to-white to-80% w-full xl:w-5/12 drop-shadow">
                    <img src={Pattern} className=" absolute  z-0 left-0" alt="" />
                    <img src={LoginBg1} className=" absolute  z-0 left-0" alt="" />
                    <div className=" relative overflow-hidden">
                        <img src={Logo} className=" w-4/12" alt="" />
                    </div>

                    <div>
                        <p className="text-lg text-white opacity-80">
                        Transform your clinic with digital efficiency in under 30 minutes.
                        </p>
                    </div>
                </div>

                <div className="flex flex-col  lg:justify-center  items-center w-full  xl:w-7/12 bg-[#f5f5f6] pt-5 xl:pt-0">
                    <div className="xl:w-7/12 px-5">
                        <div className="bg-white  px-8 md:px-10 xl:px-14 py-12  rounded-2xl">
                            <div className="mb-8">
                                <h3 className="mb-1 text-xl font-bold">Forgot Password</h3>
                                <p className="text-gray-600">
                                    Please enter your phone number to receive a verification code
                                </p>
                            </div>

                            <div style={{ padding: "0" }}>
                                {step === 1 && (
                                    <Formik
                                        initialValues={phoneFormik.initialValues}
                                        validationSchema={phoneValidationSchema}
                                        onSubmit={phoneFormik.handleSubmit}
                                    >
                                        {({ errors, touched }) => (
                                            <Form>
                                                <InputComponent
                                                    label="Phone Number"
                                                    id="phoneNumber"
                                                    name="phoneNumber"
                                                    className="mb-5 w-full"
                                                    value={phoneFormik.values.phoneNumber}
                                                    onChange={phoneFormik.handleChange}
                                                    error={phoneFormik.errors.phoneNumber}
                                                />
                                                <button
                                                    type="submit"
                                                    onClick={phoneFormik.handleSubmit}
                                                    className="min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] hover:bg-[#1a238f] text-white flex justify-center"
                                                    disabled={loading}
                                                >
                                                    {loading ? (<FaSpinner size={20} className="animate-spin" />) : ("Send OTP")}
                                                </button>
                                            </Form>
                                        )}
                                    </Formik>
                                )}
                                {step === 2 && (
                                    <Formik
                                        initialValues={otpFormik.initialValues}
                                        validationSchema={otpValidationSchema}
                                        onSubmit={otpFormik.handleSubmit}
                                    >
                                        {({ errors, touched }) => (

                                            <Form>
                                                <InputComponent
                                                    label="Enter OTP"
                                                    id="otp"
                                                    type="text"
                                                    className="mb-5 w-full"
                                                    value={otpFormik.values.otp}
                                                    onChange={otpFormik.handleChange}
                                                    error={otpFormik.errors.otp || errorMessage}
                                                />

                                                <button
                                                    type="submit"
                                                    onClick={otpFormik.handleSubmit}
                                                    className="min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] hover:bg-[#1a238f] text-white flex justify-center"
                                                    disabled={loading}
                                                >
                                                    {loading ? (<FaSpinner size={20} className="animate-spin" />) : ("Verify OTP")}
                                                </button>
                                            </Form>
                                        )}
                                    </Formik>
                                )}
                                {step === 3 && (
                                    <Formik
                                        initialValues={passwordFormik.initialValues}
                                        validationSchema={passwordValidationSchema}
                                        onSubmit={passwordFormik.handleSubmit}
                                    >
                                        {({ errors, touched }) => (

                                            <Form>
                                                <InputComponent
                                                    label="Password"
                                                    id="password"
                                                    type="password"
                                                    className="mb-5 w-full"
                                                    value={passwordFormik.values.password}
                                                    onChange={passwordFormik.handleChange}
                                                    error={passwordFormik.errors.password}
                                                />

                                                <InputComponent
                                                    label="Confirm Password"
                                                    id="confirmPassword"
                                                    type="password"
                                                    className="mb-5 w-full"
                                                    value={passwordFormik.values.confirmPassword}
                                                    onChange={passwordFormik.handleChange}
                                                    error={passwordFormik.errors.confirmPassword}
                                                />

                                                <button
                                                    type="submit"
                                                    onClick={passwordFormik.handleSubmit}
                                                    className="min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] hover:bg-[#1a238f] text-white flex justify-center"
                                                    disabled={loading}
                                                >
                                                    {loading ? (<FaSpinner size={20} className="animate-spin" />) : ("Reset Password")}
                                                </button>
                                            </Form>
                                        )}
                                    </Formik>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default ForgotPassword;
